/*
	CSS
*/
require('../css/load-main.css');
require('../css/login.css');

/*
	scripts (as conventional globals)
*/
require("script!./vendor/jquery.min.js");
require("script!./vendor/flat-ui-pro.min.js");


// WEBPACK FOOTER //
// ./assets/js/login.js